import { j as t } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import o from "../../../../string-table.js";
import "@ionic/react";
import "../../../../../FeatureFlagProvider-BBppjvNP.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as m } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function O(n) {
  const {
    title: e,
    about: r,
    editable: i
  } = n;
  return /* @__PURE__ */ t(m, {
    title: e ?? o("SUB_PROFILE_ABOUT_HEADER"),
    onEditClick: i != null && i.isEditable ? i.onEditAboutMe : void 0,
    children: /* @__PURE__ */ t("div", {
      children: /* @__PURE__ */ t("p", {
        style: {
          marginBottom: 0,
          lineHeight: "var(--swing-line-height-normal)"
        },
        children: r ? /* @__PURE__ */ t("span", {
          css: {
            whiteSpace: "pre-line"
          },
          children: r
        }) : /* @__PURE__ */ t("span", {
          style: {
            fontStyle: "italic"
          },
          children: i != null && i.isEditable ? `${o("SUB_PROFILE_ABOUT_EDIT_EMPTY")}.` : o("SUB_PROFILE_NO_INFORMATION")
        })
      })
    })
  });
}
export {
  O as AboutMe
};
